import { useState, useEffect, useRef, useContext, createContext } from 'react';
import { AimOutlined, AreaChartOutlined, BuildFilled } from '@ant-design/icons';


const ProductCardContext = createContext();

const ProductCardInfo = [
  {
    title: "Financial Builder",
    description: "Quickly create the financial plan for your venture in minutes. Structure your financials by manipulating Revenue Streams, Cost Allocation and various financials ratios to obtain optimal and realistic plan.",
    icon: <BuildFilled />,
    img: "/fb_home.png",
    alt: "Builder Dashboard Example"
  },
  {
    title: "Critical Financial Insight",
    description: "Gain in-depth financial analysis to your existing projections and confidently manage and price investments and equity capital and negotiate from a position of strength. The platform offers simplicity, efficiency, and automation with instant results.",
    icon: <AreaChartOutlined />,
    img: "https://mui.com/static/images/templates/templates-images/dash-dark.png",
    alt: "Analytics Dashboard Example"
  },
  {
    title: "Premium Strategic Business Building",
    description: "Create and obtain a complete aerial view of your business structure. Everything from Business Financials, Projections, Equity Management to full Pricing Power over investments and equity capital structure.",
    icon: <AimOutlined />,
    img: "https://www.geckoboard.com/uploads/Sales-YTD-dashboard-example-1efebb.png",
    alt: "Sales YTD Dashboard Example"
  },
]


function ProductCard({ indx, className }) {
  return (
    <div className={`product-card ${className}`}>
      <img src={ProductCardInfo[indx].img} alt={ProductCardInfo[indx].alt} />
    </div>
  );
}

function setIntervalOf(setIndexProductShow, delay) {
  let intervalId;
  intervalId = setInterval(() => {
    setIndexProductShow((prevIndex) => (prevIndex + 1) % ProductCardInfo.length);
  }, delay);
  return intervalId;
}

function ProductSwitchButton({ buttonIndx }) {
  const { indexProductShow, setIndexProductShow, intervalRef } = useContext(ProductCardContext);

  return (
    <button
      type='button'
      onMouseEnter={() => clearInterval(intervalRef.current)}
      onMouseLeave={() => intervalRef.current = setIntervalOf(setIndexProductShow, 2500)}
      className={`product-switch-button ${indexProductShow === buttonIndx ? "product-switch-button-active" : ""}`}
      onClick={() => setIndexProductShow(buttonIndx)}
    >
      {ProductCardInfo[buttonIndx].icon}
      <span>{ProductCardInfo[buttonIndx].title}</span>
      <p>{ProductCardInfo[buttonIndx].description}</p>
    </button>
  )
}

function ProductFeaturesComponent() {
  const [indexProductShow, setIndexProductShow] = useState(0);
  const intervalRef = useRef(null);

  // Automatically switch products every 2.5 seconds
  useEffect(() => {
    intervalRef.current = setIntervalOf(setIndexProductShow, 2500);

    // Clear the interval on component unmount
    return () => clearInterval(intervalRef.current);
  }, []);

  return (
    <div className="product-features">
      <h2>Products</h2>
      <p>Discover the powerful features that make our product stand out, includes easy integration with your workflow, real-time analytics and reporting, customizable user interface, secure and reliable performance, and 24/7 customer support.</p>
      <div className="product-cards-container">
        <div className="product-cards">
          <ProductCard className={indexProductShow === 0 ? "" : "hidden"} indx={0} />
          <ProductCard className={indexProductShow === 1 ? "" : "hidden"} indx={1} />
          <ProductCard className={indexProductShow === 2 ? "" : "hidden"} indx={2} />
        </div>
        <div className="product-switch-buttons-container">
          <ProductCardContext.Provider value={{ indexProductShow, setIndexProductShow, intervalRef }}>
            <ProductSwitchButton buttonIndx={0} />
            <ProductSwitchButton buttonIndx={1} />
            <ProductSwitchButton buttonIndx={2} />
          </ProductCardContext.Provider>
        </div>
      </div>
    </div>
  );
}

export default ProductFeaturesComponent;